import API from "../config/api.js";

export const BinCardService = {

  getBinCardReport(filters = {}, page = 1) {

    console.log(filters,page);

    return API.get("/api/inventory/binCard", {
      params: { ...filters, page },

    });
  },
};
